import reducer from './reducer'

import * as todosOperations from './operations'
import * as todosSelectors from './selectors'

export { todosOperations, todosSelectors }

export default reducer
